export type RegionId = "uk" | "us";

export type RegionDefinition = {
  id: RegionId;
  title: string;
  description: string;
};

export const REGIONS: readonly RegionDefinition[] = [
  {
    id: "uk",
    title: "United Kingdom",
    description: "Europe",
  },
  {
    id: "us",
    title: "United States",
    description: "North America",
  },
] as const;

export function isRegionId(value: string): value is RegionId {
  return value === "uk" || value === "us";
}

export function listRegions(): readonly RegionDefinition[] {
  return REGIONS;
}

export function getRegion(id: RegionId): RegionDefinition {
  const region = REGIONS.find((item) => item.id === id);
  if (!region) {
    throw new Error(`Unknown region: ${id}`);
  }
  return region;
}
